module.exports = __webpack_public_path__ + "img/lighting-facts.1890cd54.svg";